import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import {
  confirm, flagPortrait, getURLSegment, toggleDrawer, approvalScope
} from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';

// Components
import * as icons from '../Icons/Icons';
import FauxSelect from '../Common/FauxSelect';

const Proctor = observer(class Proctor extends React.Component {
  constructor() {
    super();
    this.requestApproval = this.requestApproval.bind(this);
    this.scheduleRB = this.scheduleRB.bind(this);
    this.messageProctor = this.messageProctor.bind(this);
    this.toggleDescription = this.toggleDescription.bind(this);
    this.renderApprove = this.renderApprove.bind(this);
    this.toggleApprovals = this.toggleApprovals.bind(this);
    this.handleAction = this.handleAction.bind(this);
  }

  componentWillMount() {
    this.state = {
      showDescription: false,
      approvals: [],
      showApprovals: false
    }
  }

  componentDidMount() {
    const { ProctorStore } = this.props.store;

    // Get proctor approval history if necessary
    if(this.props.showApprovalHistory) {
      ProctorStore.getSingleApproval(this, this.props.proctor.proctor.sid);
    }
  }

  handleAction(e, props) {
    const action = e.target.getAttribute('data-action');

    if(action === 'adminApprove') {
      this.adminApprove();
    } else if(action === 'adminDeny') {
      this.adminApprove(true);
    }
  }

  adminApprove(deny) {
    const { translation } = this.props;
    const { ProctorStore, SessionStore } = this.props.store;

    let msg = {
      heading: translation.admin_approve_confirm.heading,
      body: translation.admin_approve_confirm.body,
      button: translation.admin_approve_confirm.button
    }

    let data = {
      requestedByUserSid: SessionStore.profile.sid,
      proctorAccountSid: this.props.proctor.proctor.sid,
      status: 'allow'
    }

    if(this.props.approveForStudent) {
      msg.body = translation.admin_approve_student_confirm.body;
      data.applyToSid = this.props.userSid;
      data.applyTo = 'student';
    } else {
      data.applyToSid = SessionStore.userData.installSid;
      data.applyTo = 'install';
    }

    if(deny) {
      data.status = 'deny';

      if(this.props.approveForStudent) {
        msg.heading = translation.admin_deny_student_confirm.heading;
        msg.body = translation.admin_deny_student_confirm.body;
        msg.button = translation.admin_deny_student_confirm.button;
      } else {
        msg.heading = translation.admin_deny_confirm.heading;
        msg.body = translation.admin_deny_confirm.body;
        msg.button = translation.admin_deny_confirm.button;
      }
    }

    const callback = () => this.props.store.SessionStore.showToaster(
      this.props.translation.admin_approved, 'success'
    );

    confirm(msg, () => ProctorStore.createApproval(data, callback));
  }

  requestApproval(e) {
    const { translation } = this.props;
    const { ProctorStore, SessionStore } = this.props.store;
    const button = e.target;

    const data = {
      requestedByUserSid: SessionStore.profile.sid,
      proctorAccountSid: this.props.proctor.proctor.sid,
      examSessionSid: getURLSegment(this, 5)
    }

    const msg = {
      heading: translation.request_confirm.heading,
      body: translation.request_confirm.body,
      button: translation.request_confirm.button
    }

    confirm(msg, () => ProctorStore.requestApproval(data, this.disableButton(button)));
  }

  scheduleSmarterScheduling(proctorLocationSid) {
    this.props.parent.setState({
      proctorLocationSid
    });

    this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;

    toggleDrawer(null, this.props.parent, 'ScheduleOnline');
  }

  scheduleRB(proctorLocationSid) {
    this.props.parent.setState({
      proctorLocationSid
    });

    toggleDrawer(null, this.props.parent, 'ScheduleRB');
  }

  messageProctor(proctorSid, proctorLocationSid) {
    this.props.parent.setState({
      proctorSid,
      proctorLocationSid
    });

    this.props.store.SessionStore.getCurrentTime();

    toggleDrawer(null, this.props.parent, 'MessageThread');
  }

  disableButton(button) {
    const { translation } = this.props;
    button.setAttribute('disabled', true);
    button.textContent = translation.approval_requested;
    console.log('disable');
  }

  toggleDescription() {
    this.setState({
      showDescription: !this.state.showDescription
    })
  }

  renderApprove() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { role } = SessionStore.userData;

    let displayApproved = false;
    let displayDenied = false;
    let hideActions = false;

    if(this.state && role.toLowerCase() === 'administrator') {
      // If there are approvals, check if any
      // apply to the entire install and hide
      // the button if any do
      this.state.approvals.forEach(approval => {
        if(
          approval.status === 'deny' &&
          (
            approval.appliesTo.applicationInstall ||
            (
              approval.appliesTo.studentUser &&
              approval.appliesTo.studentUser.sid === this.props.userSid
            )
          )
        ) {
          displayDenied = true;
          hideActions = true;
        }

        if(
          approval.status === 'allow' &&
          (
            approval.appliesTo.applicationInstall ||
            (
              approval.appliesTo.studentUser &&
              approval.appliesTo.studentUser.sid === this.props.userSid
            )
          )
        ) {
          displayApproved = true;
        }
      });
    }

    let actions = [];

    if(!this.props.approveForStudent) {
      actions = [
        {
          title: translation.admin_deny,
          action: 'adminDeny'
        }
      ]

      if(!displayApproved) {
        const approveAction = {
          title: translation.admin_approve,
          action: 'adminApprove'
        }

        actions.push(approveAction);
      }
    } else {
      actions = [
        {
          title: translation.admin_deny_student,
          action: 'adminDeny'
        }
      ]

      if(!displayApproved) {
        const approveAction = {
          title: translation.admin_approve_student,
          action: 'adminApprove'
        }

        actions.push(approveAction);
      }
    }

    if(this.state && role.toLowerCase() === 'administrator') {
      return(
        <div className="proctor__session">
          {!hideActions &&
            <FauxSelect
              default={translation.actions}
              options={actions}
              onClick={this.handleAction}
              noTooltip={true}
            />
          }

          {displayDenied &&
            <strong
              className="proctor__approved denied"
            >
              <span>{translation.denied_proctor}</span>
            </strong>
          }

          {displayApproved &&
            <strong
              className="proctor__approved"
            >
              <span>{translation.approved_proctor}</span>
            </strong>
          }
        </div>
      )
    }

    return null;
  }

  toggleApprovals() {
    this.setState({
      showApprovals: !this.state.showApprovals
    });
  }

  render() {
    const { SessionStore } = this.props.store;
    const { backgroundLoadingCalls, userData } = SessionStore;
    const { role } = userData;
    const { i, proctor, translation } = this.props;

    if(backgroundLoadingCalls.indexOf('getSingleApproval') < 0) {
      return (
        <article className="proctor vcard">
          <header className="proctor__header">
            <figure className="media">
              {proctor.proctor.image &&
                <span className="proctor__avatar avatar-wrap">
                  <img
                    className="avatar"
                    src={proctor.proctor.image}
                    alt=""
                    onLoad={(e) => {flagPortrait(e, proctor.proctor.image)}}
                  />
                </span>
              }

              {!proctor.proctor.image &&
                <span className="proctor__avatar avatar-wrap">
                  <img
                    className="avatar avatar--missing"
                    src="./static/img/avatar-default.png"
                    alt="No avatar provided"
                    onLoad={(e) => {flagPortrait(e, './static/img/avatar-default.png')}}
                  />
                </span>
              }

              <figcaption className="media__copy">
                <h3 className="proctor__title fn org">
                  {proctor.proctor.accountName}
                </h3>

                <strong className="subtitle proctor__subtitle">{proctor.location.name}</strong>

                {proctor.proctor.approved &&
                  <strong className="proctor__approved"><span>{translation.approved_proctor}</span></strong>
                }

                {proctor.location &&
                  <span className="proctor__location">{proctor.location.distance} {translation.miles}</span>
                }
              </figcaption>
            </figure>

            {this.renderApprove()}

            {this.props.showProctorActions &&
              <div className="proctor__session">
                {proctor.fees && proctor.fees.userTotal !== null && proctor.fees.userTotal !== 0 &&
                  <strong className="proctor__price">
                    {currencyFormatter.format(proctor.fees.userTotal, {code: proctor.fees.currencyCode})} {proctor.fees.currencyCode}

                    {proctor.fees.proctorCollected &&
                      <span className="proctor__price__note" aria-labelledby={`${proctor.proctor.sid}-fees-tooltip`}>
                        {translation.proctor_collected}

                        {proctor.fees.proctorCollectedFeesDetail &&
                          <div className="tooltip tooltip--right">
                            <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                            <div id={`${proctor.proctor.sid}-fees-tooltip`} className="tooltip__body" role="tooltip">
                              {proctor.fees.proctorCollectedFeesDetail}
                            </div>
                          </div>
                        }
                      </span>
                    }
                  </strong>
                }

                {proctor.fees && (!proctor.fees.userTotal || proctor.fees.userTotal === 0) &&
                  <strong className="proctor__price">
                    {translation.free}
                  </strong>
                }

                {proctor.fees && proctor.fees.hasOwnProperty('lateSchedulingLeadTime') && proctor.fees.lateSchedulingLeadTime !== 0 &&
                  <span className="proctor__price" aria-describedby={`rush-${i}-tooltip`}>
                    {translation.leadtime.replace('%window%', proctor.fees.lateSchedulingLeadTime)}: {currencyFormatter.format(proctor.fees.userTotal + proctor.fees.lateSchedulingFee, {code: proctor.fees.currencyCode})} {proctor.fees.currencyCode}

                    <div className="tooltip tooltip--right">
                      <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                      <div id={`rush-${i}-tooltip`} className="tooltip__body" role="tooltip">
                        {translation.rush_tooltip.replace('%window%', proctor.fees.lateSchedulingLeadTime).replace('%price%', `${currencyFormatter.format(proctor.fees.userTotal + proctor.fees.lateSchedulingFee, {code: proctor.fees.currencyCode})} ${proctor.fees.currencyCode}`)}
                      </div>
                    </div>
                  </span>
                }

                {!proctor.proctor.approved && !proctor.proctor.pendingApproval &&
                  <button
                    className="btn"
                    onClick={(e) => {this.requestApproval(e)}}
                  >
                    {translation.request_approval}
                  </button>
                }

                {proctor.proctor.approved && !proctor.proctor.pendingApproval && proctor.location.schedulingModule !== 'register-blast' && proctor.location.schedulingModule !== 'smarter-scheduling' &&
                  <button
                    className="btn btn--success"
                    onClick={() => this.messageProctor(proctor.proctor.primaryUserSid, proctor.location.sid)}
                  >
                    {translation.request_session}
                  </button>
                }

                {proctor.proctor.pendingApproval &&
                  <span className="btn disabled">{translation.approval_requested}</span>
                }

                {proctor.location.schedulingModule === 'register-blast' && proctor.proctor.approved &&
                  <div className="tooltip tooltip--right proctor__session__icn">
                    <img src="./static/img/icn-registerblast.png" height="20" alt="RegisterBlast" role="presentation" />
                    <div id={`rb-tooltip-${i}`} className="tooltip__body tooltip__body--brief" role="tooltip">{translation.schedule_rb}</div>
                  </div>
                }

                {proctor.location.schedulingModule === 'register-blast' && proctor.proctor.approved &&
                  <button
                    className="btn btn--success"
                    onClick={() => this.scheduleRB(proctor.location.sid)}
                    aria-describedby={`rb-tooltip-${i}`}
                  >
                    {translation.request_session}
                  </button>
                }

                {proctor.location.schedulingModule === 'smarter-scheduling' && proctor.proctor.approved &&
                <div className="tooltip tooltip--right proctor__session__icn">
                  <img src="./static/img/icn-lightning.png" height="20" alt="SmarterSchedulingFastScheduling" role="presentation" />
                  <div id={`rb-tooltip-${i}`} className="tooltip__body tooltip__body--brief" role="tooltip">{translation.schedule_instant}</div>
                </div>
                }

                {proctor.location.schedulingModule === 'smarter-scheduling' && proctor.proctor.approved &&
                <button
                  className="btn btn--success"
                  onClick={() => this.scheduleSmarterScheduling(proctor.location.sid)}
                  aria-describedby={`rb-tooltip-${i}`}
                >
                  {translation.request_session}
                </button>
                }
              </div>
            }
          </header>

          <div className="proctor__details">
            {proctor.location &&
              <ul className="data vcard">
                <li>
                  <div className="adr">
                    <strong className="subtitle">{translation.location}</strong>

                    <span className="street-address">
                      {proctor.location.address1} {proctor.location.address2}
                    </span>

                    {proctor.location.place &&
                      <span className="locality">{proctor.location.place}, </span>
                    }
                    <span className="region">{proctor.location.region} </span>
                    <span className="postal-code">{proctor.location.postalCode}</span>
                  </div>

                  {proctor.location.parkingInformation &&
                    <div className="proctor__directions">
                      <strong>{translation.location_type}</strong>
                      <p>{proctor.location.locationType}</p>
                    </div>
                  }

                  {proctor.location.parkingInformation &&
                    <div className="proctor__directions">
                      <strong>{translation.parking}</strong>
                      <p>{proctor.location.parkingInformation}</p>
                    </div>
                  }
                </li>
                <li>
                  <strong className="subtitle">{translation.features_heading}</strong>
                  <ul className="proctor__features">
                    {Object.keys(translation.features).map(
                      (feature, i) =>
                      <li key={i} className={proctor.location[feature] ? 'check' : ''}>
                        {translation.features[feature]}

                        {proctor.location[feature] &&
                          <icons.iconCheck />
                        }
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            }

            {proctor.location.notes &&
              <div className="proctor__notes text-block">
                <p>{proctor.location.notes}</p>
              </div>
            }

            {
              this.state &&
              role.toLowerCase() === 'administrator' &&
              this.state.approvals.length > 0 &&

              <div className="proctor__details__approvals">
                <strong className="subtitle">
                  <button
                    className={`
                      btn--expand
                      ${this.state.showApprovals ? 'expanded' : ''}
                    `}
                    onClick={this.toggleApprovals}
                  >
                    <span className="meta">View details</span>
                  </button>

                  {translation.approval_history}
                </strong>

                {this.state.showApprovals &&
                  <table className="compact">
                    <tbody>
                      {this.state.approvals.map(
                        (approval, i) =>
                        <tr key={i}>
                          <td
                            className={approval.status === 'allow' ? 'positive' : 'negative'}
                          >
                            {approval.status}
                          </td>
                          <td>
                            {approvalScope(approval, translation)}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                }
              </div>
            }

            {/* {proctor.proctor.description &&
              <button className="proctor__more" onClick={this.toggleDescription}>
                {!this.state.showDescription &&
                  <span>
                    <icons.iconPlus />
                    {translation.more_information}
                  </span>
                }

                {this.state.showDescription &&
                  <span>
                    <icons.iconMinus />
                    {translation.less_information}
                  </span>
                }
              </button>
            }

            {proctor.proctor.description &&
              <div className={`proctor__description text-block ${this.state.showDescription ? 'visible' : ''}`}>
                <p>{proctor.proctor.description}</p>
              </div>
            } */}
          </div>
        </article>
      )
    }

    return null;
  }
})

export default translate('Proctor')(Proctor);



// WEBPACK FOOTER //
// ./src/app/components/Modules/Proctor.js